(function ($) {
    if ($('.single-master_gallery').length) {
        const masterGallerySwiper = new Swiper('.swiper.single-master-gallery-swiper', {
            // effect: 'fade',
            keyboard: {
                enabled: true,
                onlyInViewport:true,
            },
            // loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            observer: true, observeParents: true,
            allowTouchMove: false
        });
        const apartmentsList = $('.single-master-gallery-swiper .swiper-slide');
        const filterApartments = () => {
            const filters = $('form[name="apartment-filters"]').serializeArray();
            let buildingFeature = [];
            filters.forEach(function (el, index) {
                buildingFeature.push(el.value);
            })
            const filteredApartments = apartmentsList.filter(function () {
                return  buildingFeature.every(feature => String($(this).data('tag-id')).split(',').includes(feature)) ;
            })
            masterGallerySwiper.removeAllSlides();
            masterGallerySwiper.addSlide(1, filteredApartments)
            masterGallerySwiper.updateSlides()
            var myarray = [];
            $( filteredApartments).each(function( index,el ) {
                let tagId = $(this).data('tag-id').toString();
                let splittedTags = tagId.split(",")
                $.merge( myarray,$(splittedTags));
            })
            $('form[name="apartment-filters"] input').each(function (index,el) {
                if(!myarray.includes($(this).val())){
                    $(this).parents('li').addClass('not-available')
                }else {
                    $(this).parents('li').removeClass('not-available')
                }
            });
        }
        $('form[name="apartment-filters"] input').on('change', filterApartments);
        $('.clear-filters-trigger').on('click', function() {
            filterApartments();
        })
    }
})(jQuery);